export default "__VITE_ASSET__711a7b4c__"